import React, { useCallback } from 'react'

import { twMerge } from 'tailwind-merge'

import { Button } from 'src/govwell-ui'

type Props = {
  onOpen: (() => void) | undefined
  /** When grouped with other top chrome (e.g. bulk job pill), pass `inline` to skip fixed positioning. */
  placement?: 'fixed' | 'inline'
  className?: string
}

const AIAssistantPill = ({ onOpen, placement = 'fixed', className }: Props) => {
  const handleClick = useCallback(() => {
    onOpen?.()
  }, [onOpen])

  return (
    <Button
      variant="default"
      size="sm"
      icon="FaSparkles"
      onClick={handleClick}
      ariaLabel="Open AI Assistant"
      className={twMerge(
        '!h-auto !rounded-full !px-3 !py-1 !shadow-sm !transition-all !duration-200 after:!rounded-full after:!inset-shadow-none hover:!border-orange-500 hover:!bg-orange-500 hover:!text-white [&_span]:!text-[11px] [&_span]:!font-medium',
        placement === 'fixed' && '!fixed !top-[6px] !right-[14px] !z-[100]',
        className
      )}
    >
      AI Assistant
    </Button>
  )
}

export default React.memo(AIAssistantPill)
